<!-- src/App.svelte -->
<script>
  let name = ""; // Initialize name as an empty string
  let isAdmin = false; // Initially, the admin mode is off
  let password = ""; // Initialize password as an empty string
  const correctPassword = "123"; // Set the password as "123"
  let submittedNames = getStoredNames(); // Initialize submittedNames with stored data

  function handleSubmit(event) {
    event.preventDefault(); // Prevent form submission

    if (name.trim() === "") {
      alert("Please enter a name before submitting.");
      return;
    }

    // Add the submitted name to the array
    submittedNames = [...submittedNames, name];

    // Reset the name input
    name = "";

    // Save the updated submittedNames to localStorage
    saveNamesToStorage(submittedNames);
  }

  function getStoredNames() {
    const storedNames = localStorage.getItem("submittedNames");
    return storedNames ? JSON.parse(storedNames) : [];
  }

  function saveNamesToStorage(names) {
    localStorage.setItem("submittedNames", JSON.stringify(names));
  }

  function handleDelete(nameIndex) {
    // Remove the name from the array
    submittedNames = submittedNames.filter((_, index) => index !== nameIndex);

    // Save the updated submittedNames to localStorage
    saveNamesToStorage(submittedNames);
  }

  function toggleAdminMode() {
    if (isAdmin) {
      isAdmin = false; // Exit admin mode
      password = ""; // Reset password when exiting admin mode
    } else {
      // Show the password dialog only if entering admin mode
      const enteredPassword = prompt("Enter the password:");
      if (enteredPassword === correctPassword) {
        isAdmin = true;
      } else {
        alert("Incorrect password. Admin mode not activated.");
      }
    }
  }
</script>

<main>
  <button on:click={toggleAdminMode}>{isAdmin ? "Exit Admin" : "Admin"}</button>

  <form on:submit={handleSubmit}>
    <label for="name">Enter your name:</label>
    <input type="text" id="name" bind:value={name} />
    <button type="submit">Submit</button>
  </form>

  {#if name} <!-- Only show the name if it is not empty -->
    <h1>Hello, {name}!</h1>
  {/if}

  {#if submittedNames.length > 0}
    <div>
      <h2>Submitted Names:</h2>
      <ul>
        {#each submittedNames as submittedName, index}
          <li>
            {submittedName}
            {#if isAdmin}
              <button on:click={() => handleDelete(index)}>Delete</button>
            {/if}
          </li>
        {/each}
      </ul>
    </div>
  {/if}
</main>

<style>
  main {
    text-align: center;
    padding: 2em;
    max-width: 360px;
    margin: 0 auto;
    background-color: #f1f1f1;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  h1 {
    color: #ff6347;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 300;
    margin-bottom: 0.5em;
  }

  h2 {
    color: #007bff;
    font-size: 1.8em;
    font-weight: 500;
    margin-bottom: 1em;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    margin: 1em 0;
    padding: 0.5em;
    background-color: #f9f9f9;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s ease;
  }

  li:hover {
    background-color: #e9e9e9;
  }

  button {
    margin: 1em 0;
    padding: 0.5em 1em;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  button:hover {
    background-color: #0056b3;
  }
</style>

